<template>
    <div v-if="show" class="d-flex align-items-center ml-2" style="gap: 0.3rem">
        <b-spinner variant="secondary" small label="Please wait..."></b-spinner>
    </div>
</template>

<script>
export default {
    props: {
        show: { type: Boolean, required: true }
    }
}
</script>
